<template>
  <div>
    <v-app>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <div>
          <v-tabs background-color="#51bdcb" icons-and-text dark grow>
            <v-tab>
              <v-icon large>{{ tabIcon }}</v-icon>
              <div class="pt-2">{{ tabName }}</div>
            </v-tab>
            <v-tab-item>
              <v-card class="px-4">
                <v-card-text>
                  <v-form ref="loginForm" v-model="dialog" lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          autofocus
                          color="#51bdcb"
                          label="E-Mail"
                          v-model="email"
                          @keyup.enter="loader = 'loading'"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          :type="show ? 'text' : 'password'"
                          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                          v-model="password"
                          label="Mot de passe"
                          color="#51bdcb"
                          @keyup.enter="loader = 'loading'"
                          @click:append="show = !show"
                        ></v-text-field>
                      </v-col>
                      <v-col v-if="!checkCookie()" cols="12">
                        <v-checkbox
                          v-model="cookieSelected"
                          label="Enregistrer l'email pour les prochaines connexions"
                        ></v-checkbox>
                      </v-col>
                      <v-col class="d-flex" cols="12"> </v-col>
                      <v-spacer></v-spacer>
                      <v-col v-if="blankError" class="col-12">
                        <v-alert type="warning" elevation="2">
                          Veuillez remplir tous les champs s'il vous plaît
                        </v-alert>
                      </v-col>
                      <v-col v-if="authError" class="col-12">
                        <v-alert type="error" elevation="2">
                          Authentification incorrect
                        </v-alert>
                      </v-col>
                      <v-col class="d-flex" cols="12">
                        <v-btn
                          id="btn"
                          :loading="loading"
                          :disabled="loading"
                          x-large
                          block
                          color="#51bdcb"
                          @click="loader = 'loading'"
                        >
                          Se connecter
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-dialog>
    </v-app>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies';
import { LOGIN } from '../graphql/GraphQLMutations';

export default {
  name: 'Login',

  data: () => ({
    show: false,
    dialog: true,
    password: '',
    tabName: 'Authentification',
    tabIcon: 'mdi-account',
    email: '',
    emailRules: [
      (v) => !!v || "L'e-mail doit être rempli",
      (v) => /.+@.+\..+/.test(v) || "L'e-mail doit être valide",
    ],
    blankError: false,
    authError: false,
    cookieSelected: false,
    loader: null,
    loading: false,
  }),

  watch: {
    async loader() {
      if (this.loader === 'loading') {
        // loader attributs
        const l = this.loader;
        this[l] = !this[l];

        // canceled errors
        this.blankError = false;
        this.authError = false;

        // Check not empty fields
        if (this.email && this.password) {
          this.blankError = false;
          this.$apollo
            .mutate({
              mutation: LOGIN,
              variables: {
                email: this.email,
                password: this.password,
              },
            }) // Query
            .then((data) => {
              // Creation of the token
              if (this.cookieSelected) {
                VueCookies.set('authCookie', this.email, '7d');
              }

              if (localStorage) {
                localStorage.setItem('apollo-token', data.data.login.token);
              }

              // Result
              this[l] = false;
              this.loader = null;

              this.dialog = false;

              this.$router.push('projects');
              document.location.reload();
            })
            .catch((error) => {
              this[l] = false;
              this.loader = null;

              this.authError = true;
              console.error(error); // eslint-disable-line no-console
            });
        } else {
          this[l] = false;
          this.loader = null;

          this.blankError = true;
        }
      }
    },
  },

  methods: {
    checkCookie() {
      if (VueCookies.get('authCookie')) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (VueCookies.get('authCookie')) {
      this.email = VueCookies.get('authCookie');
    }
  },
};
</script>

<style scoped>
#btn {
  color: white;
}
</style>
